module.exports = __webpack_public_path__ + "assets/img/reward.b41b8a07.png";